import {toast} from 'react-toastify';

export const HAS_ACCESSED_APP_OPTIONS = [
  {label: 'All', value: ''},
  {label: 'Has Accessed App', value: 'true'},
  {label: 'Has Not Accessed App', value: 'false'},
];

export const getStatusColor = hasAccessed => {
  return hasAccessed ? 'green' : 'default';
};

export const copyToClipboard = text => {
  navigator.clipboard.writeText(text).then(() => {
    toast.success('Copied to clipboard');
  });
};

export const formatAccessInfo = accessInfo => {
  if (!accessInfo) return null;
  const country = accessInfo?.country || 'N/A';
  const ip = accessInfo?.ip || 'N/A';
  return `${country} (${ip})`;
};
